export default __webpack_public_path__ + "static/media/icon-reader.2663691f.svg";